const RouteNames = {
  PROGRAM_MAIN: 'programMain' as const,
  PROGRAM_HOME: 'programHome' as const,
  MINI_PAGE: 'miniPage' as const,
  COLLECTION_DETAILS: 'collectionDetails' as const,
  BROWSE: 'browse' as const,
  SEARCH: 'search' as const,
  DOMAIN_SUBDOMAIN_COLLECTIONS: 'domainSubdomainCollections' as const,
  OBJECTIVES: 'programSkillsObjectives' as const,
  SKILLSET_SKILL_RECOMMENDATIONS: 'programSkillsetSkillRecommendations' as const,
  ENTERPRISE_LEARNER_HOME: 'enterpriseLearnerHome' as const,
  ENTERPRISE_LEARNER_LANDING_ROOT: 'enterpriseLearnerLandingRoot' as const,
  ENTERPRISE_LEARNER_LANDING: 'enterpriseLearnerLanding' as const,
  ENTERPRISE_LEARNER_LANDING_ORG_SCOPED_ROOT: 'enterpriseLearnerLandingOrgScopedRoot' as const,
  ENTERPRISE_LEARNER_LANDING_ORG_SCOPED: 'enterpriseLearnerLandingOrgScoped' as const,
  ENTERPRISE_LEARNER_ROOT: 'enterpriseLearnerRoot' as const,
  ENTERPRISE_LEARNER_SEARCH: 'enterpriseLearnerSearch' as const,
  ENTERPRISE_LEARNER_DOMAINS: 'enterpriseLearnerDomains' as const,
  ENTERPRISE_PRIVACY_NOTICE: 'enterpriseLearnerPrivacyNotice' as const,
  VIEW_ALL_COLLECTIONS: 'viewAllCollections' as const,
  VIEW_ALL_TAILORED_LEARNING: 'viewAllTailoredLearning' as const,
  PROJECTS: 'projects' as const,
  ROLES: 'roles' as const,
  SKILL_RECOMMENDATIONS: 'programSkillRecommendations' as const,
  LEARNER_ONBOARDING: 'learnerOnboarding' as const,
};

export default RouteNames;
export const {
  PROGRAM_MAIN,
  PROGRAM_HOME,
  MINI_PAGE,
  COLLECTION_DETAILS,
  BROWSE,
  SEARCH,
  DOMAIN_SUBDOMAIN_COLLECTIONS,
  OBJECTIVES,
  SKILLSET_SKILL_RECOMMENDATIONS,
  ENTERPRISE_LEARNER_HOME,
  ENTERPRISE_LEARNER_ROOT,
  ENTERPRISE_LEARNER_SEARCH,
  VIEW_ALL_COLLECTIONS,
  VIEW_ALL_TAILORED_LEARNING,
  PROJECTS,
  ROLES,
  SKILL_RECOMMENDATIONS,
  LEARNER_ONBOARDING,
} = RouteNames;
